import {createContext} from 'react'

const TrasladoProductoInventarioContext = createContext()

export default TrasladoProductoInventarioContext